import AddButton from "components/Button/AddButton";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EmptyString, FormTypeAdd, PageSize } from "utils/Constant";
import { money } from "utils/helpers";
import { RoomService } from "services/RoomService";
import { MainBodyCard } from "components/Cards/MainBodyCard";
import { PagesTitle } from "components/Cards/PagesTitle";
import { FilterCard } from "components/Cards/FilterCard";
import { GridEditButton } from "components/Button/GridEditButton";
import { GridDeleteButton } from "components/Button/GridDeleteButton";
import { useModal } from "utils/context/ModalContext";
import DataTable from "components/DataTable";
import Pagination from "components/Input/PaginationButton";

export default function RoomSetup(){
    let navigate = useNavigate()

    const firstLoad = useRef(true)
    const debounceRef = useRef(null)

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    
    const { fetchRoomList, fetchDeleteRoom } = RoomService()

    const [roomTypeId, setRoomTypeId] = useState(EmptyString)
    const [roomStatus, setRoomStatus] = useState(EmptyString)

    const [roomTypeName, setRoomTypeName] = useState(EmptyString)

    // DATA
    const [roomList, setRoomList] = useState([])

    // GRID
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const handlePageChange = async (newIndex) => {
        try {
            showLoading()

            const res = await fetchRoomList(
                roomTypeName,
                roomTypeId,
                roomStatus,
                PageSize,
                newIndex
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setRoomList(res)
            setTotalPages(total)
            setPageIndex(newIndex)
        } finally {
            hideLoading()
        }
    }

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "roomNumber",
            header: "Room Number",
            render: (row) => row.roomNumber.toUpperCase()
        },
        {
            key: "roomTypeName",
            header: "Room Type",
        },
        {
            key: "priceDaily",
            header: "Daily Price",
            render: (row) => money(row.priceDaily)
        },
        {
            key: "priceMonthly",
            header: "Monthly Price",
            render: (row) => money(row.priceMonthly)
        },
        {
            key: "priceYearly",
            header: "Yearly Price",
            render: (row) => money(row.priceYearly)
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.roomId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.roomId)} size="w-3" />
                </div>
            ),
        },
    ]

    const addBtnClick = () => {
        navigate("/setting/room-setup/form?roomId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (roomId) => {
        navigate("/setting/room-setup/form?roomId=" + roomId + "&formType=Edit")
    }
    const deleteBtnClick = async (roomId) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            const res = await fetchDeleteRoom(roomId)
            if (!res) return 

            showSuccess({
                onSuccess: async () => {
                    await handlePageChange(pageIndex)
                }
            })
        } finally {
            hideLoading()
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            if (firstLoad.current) {
                handlePageChange(0)

                firstLoad.current = false
            }
            else {
                if (debounceRef.current) {
                    clearTimeout(debounceRef.current)
                }
        
                debounceRef.current = setTimeout(() => {
                    handlePageChange(0)
                }, 500)
            }
        }

        onLoad()
    },[roomTypeName])

    return(
        <MainBodyCard>
            <PagesTitle title='Room Setup' />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <FilterCard title='Room Number'>
                    <input className="input" value={roomTypeName} onChange={(e) => setRoomTypeName(e.target.value)} />
                </FilterCard>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="mt-5">
                <DataTable
                    columns={columns}
                    data={roomList?.data?.listData ?? []}
                />
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </MainBodyCard>
    )
}